import React from 'react';
import { Provider } from 'react-redux';
import { Router } from 'react-router';
import history from '../history';

import Data from '../Data';
import Routes from './Routes';

export default () => (
  <Provider store={Data.store}>
    <Router history={history}>
      <Routes />
    </Router>
  </Provider>
);
